module.exports = __webpack_public_path__ + "img/outernational.81d8e6e7.png";